import React, { useState, useEffect } from "react";
import "../../components/AddProfile/AddProfile.css";
import axios from "axios";

const AddFrieghtChargesDomestic = ({
  tokenStorage,
  openAddProfile,
  setOpenAddProfile,
  successMessage,
  setSuccessMessage,
}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [originCodeResponse, setoriginCodeResponse] = useState([]);
  const [designationResponse, setDesignationResponse] = useState([]);

  const [formData, setFormData] = useState({
    Origin_Code: "",
    Destination_Code: "",
    Lane: "",
    Prime_GCR_Lean_SCR: "",
    MIN: "",
    Normal: "",
    PER_KG_RATE: "",
    AVI_HANDLING: "",
    DDC: "",
    FLC: "",
    XRAY: "",
    XRAY: "",
    XRAY_MIN: "",
    HCC: "",
    HCC_MIN: "",
    OUT_XCC: "",
    XCC_MIN: "",
    OUT_TSP: "",
    OUT_TSP_MIN: "",
    IN_TSP: "",
    IN_TSP_MIN: "",
    created_Date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}/userpost/AddAirFreightDomestic`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Handle the response here (e.g., show a success message)
      // console.log("Data successfully posted:", response.data);

      setSuccessMessage("Data successfully submitted");
   

      // Optionally, reset the form
      setFormData({
        Origin_Code: "",
        Destination_Code: "",
        Lane: "",
        Prime_GCR_Lean_SCR: "",
        MIN: "",
        Normal: "",
        PER_KG_RATE: "",
        AVI_HANDLING: "",
        DDC: "",
        FLC: "",
        XRAY: "",
        XRAY_MIN: "",
        HCC: "",
        HCC_MIN: "",
        OUT_XCC: "",
        XCC_MIN: "",
        OUT_TSP: "",
        OUT_TSP_MIN: "",
        IN_TSP: "",
        IN_TSP_MIN: "",
        created_Date: "",
      });
      tokenStorage();
      setOpenAddProfile(!openAddProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetAirFreightDomestic?Tseed=0&Origin_Code=&Destination_Code=&Lane=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {          
          setoriginCodeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const handleSelectChange = (event) => {
    formData.Origin_Code = event.target.value;
    // updateDesignation(event.target.value);
  };

  const updateDesignation = (dept) => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetAirFreightDomestic?Tseed=0&Origin_Code=&Destination_Code=&Lane==` +
            dept,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setDesignationResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const handleSelectChangeDesignation = (event) => {
    formData.Destination_Code = event.target.value;
  };

  useEffect(() => {
    // Concatenate the origin and destination codes with a dash
    const newLane = `${formData.Origin_Code}-${formData.Destination_Code}`;
    setFormData((prevData) => ({
      ...prevData,
      Lane: newLane,
    }));
  }, [formData.Origin_Code, formData.Destination_Code]);

  // const handleSelectChangeOrigin = (event) => {
  //   formData.Origin_Code = event.target.value;
  // };


  const handleSelectChangeOrigin = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      Origin_Code: value,
    }));
  };

  const handleSelectChangeDestination = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      Destination_Code: value,
    }));
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="employeeDetail">
        {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )}
        <form className="employee-form" onSubmit={handleSubmit}>
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={4}></td>
            </tr>
            <tr className="tableHeading">
              <td>Origin Code</td>
              <td>Destination Code</td>     
              <td>Lane</td>
              <td>Prime/GCR/Lean/SCR</td>
            </tr>

            <tr>
              <td>
                <select
                  name="Origin_Code"
                  onChange={handleSelectChangeOrigin}
                  style={{ height: "29px", width: "13rem" }}
                >
                  <option value="" style={{ width: "5rem" }}>
                    Select an option
                  </option>
                  {originCodeResponse.map((item) => (
                    <option value={item.Origin_Code}>{item.Origin_Code}</option>
                  ))}
                </select>
              </td>
              <td>
               
                <select
                  name="Destination_Code"
                  onChange={handleSelectChangeDestination}
                  style={{ height: "29px", width: "13rem" }}
                >
                  <option value="" style={{ width: "5rem" }}>
                    Select an option
                  </option>
                  {originCodeResponse.map((item) => (
                    <option value={item.Destination_Code}>
                      {item.Destination_Code}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="Lane"
                  value={formData.Lane}
                
                  onChange={handleChange}
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="Prime"
                  value={formData.Prime}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={4}></td>
            </tr>
            <tr className="tableHeading">
              <td>MIN</td>
              <td>Normal</td>
              <td>Per Kg Rate</td>
              <td>AVI HANDLING</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="MIN"
                  value={formData.MIN}
                  placeholder="Please enter"
                  onChange={handleChange}
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="Normal"
                  value={formData.Normal}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="PER_KG_RATE"
                  value={formData.PER_KG_RATE}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>

              <td>
                <input
                  type="text"
                  name="AVI_HANDLING"
                  value={formData.AVI_HANDLING}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>DDC</td>
              <td>FLC 2/200</td>
              <td>X-RAY</td>
              <td>X-RAY/MIN</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="DDC"
                  value={formData.DDC}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="FLC"
                  value={formData.FLC}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />{" "}
              </td>
              <td>
                <input
                  type="text"
                  name="XRAY"
                  value={formData.XRAY}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />{" "}
              </td>
              <td>
                <input
                  type="text"
                  name="XRAY_MIN"
                  value={formData.XRAY_MIN}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={4}></td>
            </tr>
            <tr className="tableHeading">
              <td>HCC</td>
              <td>OUT XCC</td>
              <td>OUT TSP</td>
              <td>IN TSP</td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  name="HCC"
                  value={formData.HCC}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />{" "}
              </td>
              <td>
                <input
                  type="text"
                  name="OUT_XCC"
                  value={formData.OUT_XCC}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />{" "}
              </td>
              <td>
                <input
                  type="text"
                  name="IN_TSP"
                  value={formData.IN_TSP}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />{" "}
              </td>
              <td>
                <input
                  type="text"
                  name="OUT_TSP"
                  value={formData.OUT_TSP}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />{" "}
              </td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addEmployee-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddFrieghtChargesDomestic;
